<nav id="sidebar" class="active">
  <a href="index.html" class="logo"><img src="/assets/images/ozm-logo.png" /></a>
  
  <!-- Loading State -->
  <div *ngIf="isLoading" class="text-center py-3">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only">Loading...</span>
    </div>
    <p class="loading-text">Loading categories...</p>
  </div>
  
  <!-- Error State -->
  <div *ngIf="error" class="error-container p-3">
    <p class="error-text">{{ error }}</p>
    <button class="retry-btn btn btn-sm btn-outline-light" (click)="retryLoading()">
      Retry
    </button>
  </div>
  
  <!-- Categories List -->
  <ul class="list-unstyled components mb-5" *ngIf="!isLoading && !error">
    <!-- My Favorites Link -->
    <li class="favorites-link" [class.active]="activeSpecialLink === 'favorites'">
      <a (click)="onFavoritesClick()" 
         class="category-link special-link">
        <i class="fas fa-heart category-icon"></i>
        <span class="category-name">My Favorites</span>
        <span class="app-count" *ngIf="isLoggedIn">({{ totalFavoritesCount }})</span>
      </a>
    </li>
    
    <!-- Cashback Request Link -->
    <li class="cashback-link" [class.active]="activeSpecialLink === 'cashback'" *ngIf="isLoggedIn">
      <a (click)="onCashbackClick()" 
         class="category-link special-link">
        <i class="fas fa-money-bill-wave category-icon"></i>
        <span class="category-name">Request Cashback</span>
      </a>
    </li>
    
    <!-- Divider -->
    <li class="divider"></li>
    
    <li
      *ngFor="let category of categories" 
      [class.selected]="selectedCategory?.categoryId === category.categoryId">
      <a class="category-link" (click)="onCategoryClick(category)" style="cursor: pointer;">
        <img 
          [src]="getIconPath(category)" 
          (error)="handleImageError($event)"
          class="category-icon"
          [alt]="category.name" />
        <span class="category-name">{{ category.name }}</span>
        <span class="app-count" *ngIf="isLoggedIn && category.favoriteCount !== undefined">
          ({{ category.favoriteCount }})
        </span>
        <span class="app-count" *ngIf="!isLoggedIn">
          <!-- ({{ category.apps.length }}) -->
        </span>
      </a>
    </li>

    <!-- Fallback when no categories are available -->
    <li *ngIf="categories.length === 0" class="text-center py-3">
      <p class="no-categories-text">No categories available</p>
    </li>
  </ul>
</nav>
